import { useApplicationStore } from '@data';
import { PageHeading, Paragraph } from '@quickmd-llc/design-system';
import { FormSlideProps } from '../hooks/useRefillCheckup/useRefillCheckupState';
import { WeightForm } from './WeightForm';
import { ButtonForm } from './ButtonForm';

export function CheckupFormSlideTemplate({
  question,
  isWeight,
}: FormSlideProps) {
  const activeRefill = useApplicationStore(
    ({ patient }) => patient.activeRefill,
  );

  return (
    <div className="flex flex-1 flex-col">
      <PageHeading className="mb-1">Refill Questionnaire</PageHeading>

      <div className="mb-6 flex gap-1">
        <Paragraph className="text-shade-80">For your</Paragraph>
        <Paragraph className="font-medium">
          {activeRefill?.brand} refill
        </Paragraph>
      </div>

      {isWeight ? <WeightForm /> : <ButtonForm question={question} />}
    </div>
  );
}
